import React from "react";
import PropTypes from 'prop-types';
import _ from 'lodash';
import FamilyItem from './familyItem';

class FamilyList extends React.PureComponent {

	renderFamilyItem = (item, index) => {
		const { alertFamilyIds, onToggleFamilyStatus }	= this.props;
		const { id, name }	= item;
		const status = _.findIndex(alertFamilyIds, (x) => x === id);
		const className = index % 6 > 2 ? 'evenLineFamily' : 'oddLineFamily';
		return (
			<FamilyItem
				key={id}
				id={id}
				name={name}
				status={status >= 0}
				className={className}
				onToggleFamilyStatus={onToggleFamilyStatus}
			/>
		)
	}

	renderRoomItems = () => {
		const { allFamilies }	= this.props;
		return (
			<div className='listContainer'>
				{
					allFamilies.map((item, index) =>
						this.renderFamilyItem(item, index),
					)
				}
      </div>
		)
	}

  render() {
    return(
			<div className='component-familyList' >
				{ this.renderRoomItems() }
      </div>
    )
  }
}

FamilyList.defaultProps = {
};

FamilyList.propTypes = {
	alertFamilyIds: PropTypes.arrayOf(
		PropTypes.string,
	),
	allFamilies: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			name: PropTypes.string.isRequired,
			userId: PropTypes.string.isRequired,
		})
	),
	onToggleFamilyStatus: PropTypes.func.isRequired,
};

export default FamilyList;
